import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div 
      aria-live="polite" 
      class="fixed bottom-4 right-4 z-[1100] flex flex-col space-y-2 max-w-md w-full"
    >
      @for (toast of toasts(); track toast.id) {
        <div 
          class="p-4 rounded-md shadow-lg transition-all duration-200 transform translate-y-0 opacity-100 flex items-start" 
          [ngClass]="{
            'bg-green-100 border-l-4 border-green-500 text-green-700': toast.type === 'success',
            'bg-red-100 border-l-4 border-red-500 text-red-700': toast.type === 'error',
            'bg-blue-100 border-l-4 border-blue-500 text-blue-700': toast.type === 'info',
            'bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700': toast.type === 'warning'
          }"
          role="alert"
        >
          <div class="flex-1">
            <p class="text-sm font-medium">{{ toast.message }}</p>
          </div>
          <button 
            type="button"
            (click)="closeToast(toast.id)"
            class="ml-4 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      }
    </div>
  `
})
export class ToastContainerComponent {
  private toastService = inject(ToastService);
  
  toasts = computed(() => this.toastService.toasts());
  
  closeToast(id: number): void {
    this.toastService.remove(id);
  }
}